import { appData } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="p-8 md:p-10 rounded-2xl bg-gradient-to-br from-primary-500 to-primary-600 text-center text-white">
            <div className="flex items-center justify-center gap-2 mb-4">
              <span className="w-12 h-12 flex items-center justify-center rounded-2xl bg-white/20 text-2xl">🍉</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-heading mb-3">{appData.title}</h2>
            <p className="text-white/80 text-sm md:text-base mb-8">{appData.subtitle}</p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
              {appData.steps.map((step) => (
                <div key={step.step} className="flex flex-col items-center p-4 rounded-xl bg-white/10">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-white/20 mb-3">
                    <i className={`${step.icon} text-xl text-white`}></i>
                  </span>
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-white text-primary-600 text-xs font-bold mb-2">
                    {step.step}
                  </span>
                  <p className="text-white/90 text-sm">{step.text}</p>
                </div>
              ))}
            </div>

            <div className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white text-primary-600 font-semibold text-sm cursor-pointer hover:bg-white/90 transition-colors whitespace-nowrap">
              <i className="ri-smartphone-line"></i>
              了解更多
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}